import CardDiv from "modules/common/card-div/CardDiv";
import React from "react";
const ImportantNotes = () => {
  return (
    <CardDiv
      title={"Important Notes"}
      component={
        <ol>
          <strong>
            <li>
              The order from the left side search result will be transferred to
              the right.
            </li>
            <li>
              Once the transfer is completed, the user on the left will no
              longer be available.
            </li>
            <li>This is a one-time operation and can't be undone.</li>
            <li>This activity is logged in the system.</li>
            <li>
              The following data will not be moved: Phone number, Email address,
              Diet plan, Reminders, Tags, and Tag History.
            </li>
          </strong>
        </ol>
      }
    />
  );
};

export default ImportantNotes;
